export default __webpack_public_path__ + "static/media/sorceryLogo.cbcfe3ef.webp";